import {Component, OnDestroy, OnInit} from '@angular/core';
import {ProjectConstants} from '../../../project-constants';
import {LocalCustomerModel} from '../../../../models/LocalCustomerModel';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Subscription} from 'rxjs';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalCustomerAnagrafService} from '../../../general-services/service-local-customer-anagraf/local-customer-anagraf.service';
import * as toastr from 'toastr';
import {LoaderService} from '../../../general-services/service-loader/loader.service';

@Component({
  selector: 'app-edit-local-customer-anagraf',
  templateUrl: './edit-local-customer-anagraf.component.html',
  styleUrls: ['./edit-local-customer-anagraf.component.scss']
})
export class EditLocalCustomerAnagrafComponent  extends ProjectConstants implements OnInit, OnDestroy {

  localCustomer: LocalCustomerModel;
  formValidator: FormGroup;
  formBuilder: FormBuilder;

  saveSubscribe: Subscription;
  parameterSubscribe: Subscription;

  idLocalCustomer: number;
  codLocalCustomer: string;
  localCustomerJson: any;
  description: any;
  submitted: boolean;


  constructor(private route: ActivatedRoute, private router: Router,
              private localCustomerService: LocalCustomerAnagrafService, private _Activatedroute: ActivatedRoute,
              private loaderService: LoaderService) {
    super();

    this.parameterSubscribe = this.route
      .queryParams
      .subscribe(params => {
        this.localCustomerJson = params['row'];
      });

    this.localCustomer = new LocalCustomerModel();

    this.formBuilder = new FormBuilder();

    this.formValidator = this.formBuilder.group({
      cod: [{value: '', disabled: false}, Validators.required],
      description: [{value: '', disabled: false}, Validators.required]
    });

    this.localCustomer = JSON.parse(this.localCustomerJson) as LocalCustomerModel;

    this.formValidator.patchValue({
      cod: this.localCustomer ? this.localCustomer.cod : ''
    });

    this.formValidator.patchValue({
      description: this.localCustomer ? this.localCustomer.description : ''
    });

    _Activatedroute.params.subscribe(params => {
      this.idLocalCustomer = params['id'];
      this.codLocalCustomer = params['cod'];
      this.description = params['description'];
    });
  }

  ngOnInit() {
  }

  cancel(event: any) {
    event.preventDefault();
    this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.LOCAL_CUSTOMER_ANAGRF]);
  }

  edit() {
    this.submitted = true;
    if (this.formValidator.valid) {
      this.localCustomer.cod = this.formValidator.controls['cod'].value;
      this.localCustomer.description = this.formValidator.controls['description'].value;
      this.saveSubscribe = this.localCustomerService.update(this.localCustomerService.baseUrl, this.localCustomer).subscribe(
        (result: any) => {
          if (result === -1) {
            toastr.options.timeout = 5000;
            toastr.warning('Duplicate item, Local Customer Cod already exists', 'Warning');
          } else if (result === -2) {
            toastr.options.timeout = 5000;
            toastr.warning('Element already used', 'Warning');
          } else {
            toastr.success('Local customer was edited with success', 'Success');
            this.router.navigate([this.LINKS.MASTER_DATA + this.LINKS.ANAGRAPH.LOCAL_CUSTOMER_ANAGRF]);
          }
        }, error => {
          this.loaderService.display(false);
          toastr.error('Local Customer was not edited', 'Error');
        });
    }
  }

  ngOnDestroy(): void {
    if (this.saveSubscribe) {
      this.saveSubscribe.unsubscribe();
    }
  }

  // convenience getter for easy access to form fields
  get f() { return this.formValidator.controls; }

}
